import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import hardSet from 'redux-persist/lib/stateReconciler/hardSet';
import Cookies from 'js-cookie';

import authUiReducer from './loginUiReducer';
import authDataReducer from './loginDataReducer';

const authDataPersistConfig = {
  key: 'data',
  storage,
  stateReconciler: hardSet,
  blacklist: ['isRegistered', 'isAuthenticated'],
};

const accessToken = Cookies.get('accessToken');

export default combineReducers({
  ui: authUiReducer,
  data: authDataReducer,
  // data: accessToken !== undefined
  //   ? (persistReducer(authDataPersistConfig, authDataReducer))
  //   : authDataReducer,
});
